import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { FIREARM_TYPE, FirearmAssignmentLog } from 'assets-model';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-firearm-assignment-log-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmAssignmentLogEditorComponent extends CrudEditComponent<FirearmAssignmentLog, number> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    //this.actions = [];
    if (this.item?.firearm) {
      this.editorTitle = this.editorTitle.replace('Firearm Asset', FIREARM_TYPE.typeName(this.item.firearm));
    }
  }

  backRoute(): any[] {
    return [...FIREARM_TYPE.editRouteBase, this.item?.assetId];
  }

}






